<template>
    <div
        class="p-5 md:p-20 flex"
        style="background-color: #FBFBFB"
        v-if="typeof program === 'object'"
    >
        <div class="w-full max-w-7xl mx-auto py-20 flex">
            <div class="w-1/3">
              <editable-headline field="program" :default="'Planlagt for  ' + store.proposal.title" :large="true"/>
            </div>
            <div class="w-2/3 mx-auto flex flex-col">
                <div class="mt-7 py-3">
                    <Accordion
                        v-for="day in store.days"
                        :active="day.itinerary.length > 0"
                        class="my-3"
                    >
                        <template #title>
                            <span class="text-xl mb-3">{{ day.title }}</span>
                        </template>
                        <template #content>
                            <div
                                v-for="itinerary in day.itinerary"
                                class="my-8 flex justify-between items-center"
                            >
                                <div>
                                    <p class="mt-2 flex items-center text-gray-500">
                                        <svg
                                            width="12"
                                            height="12"
                                            class="mr-2"
                                            viewBox="0 0 12 12"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M6 3.66667V6L7.75 7.75M11.25 6C11.25 8.8995 8.8995 11.25 6 11.25C3.10051 11.25 0.75 8.8995 0.75 6C0.75 3.10051 3.10051 0.75 6 0.75C8.8995 0.75 11.25 3.10051 11.25 6Z"
                                                stroke="#01798A"
                                                stroke-width="1.16667"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            />
                                        </svg>
                                        {{ new Date(itinerary.start).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }} - {{ new Date(itinerary.end).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }}
                                    </p>
                                    <p class="text-lg">
                                        <strong>{{ itinerary.name }}</strong>
                                    </p>
                                    {{ itinerary.description }}
                                </div>
                                <span @click="toggleHighlight(itinerary)" class="p-5 -m-5 cursor-pointer" :class="[itinerary.highlighted ? 'text-gray-900 hover:text-icon' : 'text-icon hover:text-gray-900']">
                                    <spinning-circle size="small" v-if="loading === itinerary.id" />
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" :fill="[itinerary.highlighted ? 'currentColor' : 'none']" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z" />
                                    </svg>
                                </span>
                            </div>
                        </template>
                    </Accordion>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import {useProposalOldStore} from "@/Stores/ProposalOld";
import Accordion from "@/ComponentsDeprecated/Accordion/Accordion";
import {computed} from "vue";
import SpinningCircle from "@/ComponentsDeprecated/Loaders/SpinningCircle";
import {ref} from 'vue';
import EditableHeadline from "@/ComponentsDeprecated/Proposal/EditableHeadline";

const store = useProposalOldStore()
const loading = ref(null);
const program = computed(function () {
    let p = store.days
    for (let i = 0; i < Object.keys(p).length; i++) {
        p[i].itinerary = [];
        store.activities.forEach((activity) => {
            const activity_date = new Date(activity.start)
            if(activity_date.getDate() === p[i].date.getDate()
                && activity_date.getMonth() === p[i].date.getMonth()
                && activity_date.getFullYear() === p[i].date.getFullYear()) {
                p[i].itinerary.push(activity)
            }
        })

        store.eateries.forEach((eatery) => {
            const eatery_date = new Date(eatery.start)
            if(eatery_date.getDate() === p[i].date.getDate()
                && eatery_date.getMonth() === p[i].date.getMonth()
                && eatery_date.getFullYear() === p[i].date.getFullYear()) {
                p[i].itinerary.push(eatery)
            }
        })
    }
    return p
});

function toggleHighlight(itinerary) {
    loading.value = itinerary.id
    axios.post(route('api.proposal.highlight.toggle', {proposal: store.proposal.id, itinerary: itinerary.id}))
        .then((response) => {
            if(response.data) {
                if(itinerary.type === 'activity') {
                    const index = store.activities.findIndex(obj => {
                        return obj.id === itinerary.id;
                    });
                    store.activities[index].highlighted = !store.activities[index].highlighted;
                }
                else if(itinerary.type === 'eatery') {
                    const index = store.eateries.findIndex(obj => {
                        return obj.id === itinerary.id;
                    });
                    store.eateries[index].highlighted = !store.eateries[index].highlighted;
                }
            }
        }).finally(() => {
            loading.value = null;
        })
}
</script>
